export const lottery = {
  tripletaRetrySamePurchase:
    "Die aankoop kon nie bevestig word nie. Probeer weer dieselfde weddenskap om dit te herwin of te voltooi sonder om 'n duplikaat te skep.",
  tripletaLoadError: "Kaartjies kon nie gelaai word nie.",
  tripletaRetry: "Probeer weer",
  tripletaPrevious: "Vorige",
  tripletaNext: "Volgende",
  tripletaTicketTypes: "Kaartjie-tipe",
  tripletaClassicTickets: "Klassieke lotery",
  lotteryPlay: "Speel",
  lotteryResults: "Uitslae",
  myLotteryTicket: "My kaartjies",
  lotteryMyTickets: "My loterykaartjies",
  lotteryBackBtn: "Terug na loterye",
  lotteryMyBets: "My weddenskappe",
  lotteryFloatButtonTitle: "Weddenskappe",
  lotteryTooltipText: "Wys al my weddenskappe",
  lotteryDraw: "Trekking",
  lotteryAnimal: "Dier",
  lotterySelectAnimal: "Kies 'n dier",
  lotterySelectDraw: "Kies 'n trekking",
  lotteryAmount: "Bedrag",
  lotteryTotalBet: "Totale weddenskap",
  lotteryBuyTicket: "Koop kaartjie",
  lotteryCreateTicket: "Skep kaartjie",
  lotteryCreatedTicket: "Kaartjie(s) suksesvol geskep!",
  lotteryErrorTicket: "Fout met die skep van die kaartjie",
  lotteryHideResults: "Versteek uitslae",
  lotteryShowResults: "Wys uitslae",
  lotteryDrawActive: "Aktiewe trekking",
  lotteryErrorLoadingData: "Fout met die laai van data",
  lotteryErrorInput: "Voeg asseblief ten minste een weddenskap by voordat jy speel.",
  lotteryErrorBalance: "Onvoldoende saldo. Herlaai asseblief jou saldo.",
  lotteryErrorBetAmount: "Die minimum weddenskap is R 50",
  lotteryErrorMinBetAmount: "Minimum weddenskap is R {{min}}",
  lotteryErrorMaxBetAmount: "Maksimum weddenskap is R {{max}}",
  lotteryErrorBetStep: "Weddenskappe moet veelvoude van {{step}} wees (50, 60, 70...).",
  lotteryBetHintMin: "Min {{min}} Bs",
  lotteryBetHintStep: "veelvoude van {{step}}",
  lotteryBetHintMax: "maks {{max}} Bs",
  lotteryErrorSelectDrawAnimal: "Kies asseblief 'n trekking, 'n dier en voer 'n geldige wedbedrag in.",
  lotteryMode: "Jy kan slegs tot 4 diere in Moderne modus kies.",
  lotteryTicketCreatedMessage: "Kaartjie suksesvol geskep",
  lotteryTicketCreatedMessageError: "Fout met die skep van die kaartjie",
  lotteryCardGame: "Binnekort beskikbaar",
  lotteryModalCode: "Kaartjiekode",
  lotteryModalDate: "Skepdatum",
  lotteryModalTotal: "Totale bedrag",
  lotteryModalWon: "Gewen bedrag",
  lotteryModalAnimals: "Gespeelde diere",
  lotteryModalTitle: "Kaartjiebesonderhede",
  lotteryModalCancel: "Kanselleer",
  lotteryModalConfirm: "Aanvaar",
  lotteryModalAmount: "Bedrag",
  lotteryModalNoTickets: "Jy het geen loterykaartjies nie",
  lotteryTokenNotFound: "Token nie gevind nie",
  lotteryActiveRouletteResults: "Aktiewe roulette-uitslae",
  lotteryGameWinner: "Wenner",
  lotteryGamePrize: "Geen wenners",

  lotteryModalInput: "Voer jou wedbedrag in",
  lotteryModalAddBet: "Voeg weddenskap by",
  lotteryModalCancelBet: "Kanselleer",

  lotteryTraditional: "Tradisioneel",
  lotteryModern: "Modern",
  selectLotteryType: "Kies loterytipe",
  results: "Uitslae",
  resultLotteryModern: "Moderne lotery-uitslag",
  resultLotteryTradicional: "Tradisionele lotery-uitslag",
  lotteryDate: "Loterydatum",
  lotteryNoResults: "Geen uitslae beskikbaar vir hierdie datum nie",

  // ── Tripleta (modaliteit) ──
  tripleta: "Tripleta",
  tripletaTitle: "Tripleta",
  tripletaSubtitle:
    "Kies 3 figure van 'n speletjie. As almal in die volgende {{n}} trekkings uitkom, wen jy bedrag × vermenigvuldiger.",
  tripletaStep1: "1. Kies die lotery",
  tripletaStep2: "2. Kies 3 figure",
  tripletaPays: "betaal {{factor}}×",
  tripletaFiguresCount: "{{count}} figure",
  tripletaNextDraw: "Volgende trekking {{time}}",
  tripletaSelectedCount: "{{count}} van 3",
  tripletaDrawsPanel: "Trekkings wat jy speel",
  tripletaDrawsHint: "Jou kaartjie speel hierdie {{n}} trekkings. Verkope sluit minute voor die eerste een.",
  tripletaTomorrow: "môre",
  tripletaContinue: "Gaan voort",
  tripletaClear: "Maak skoon",
  tripletaVerify: "Hersien jou weddenskap",
  tripletaEnterAmount: "Voer die bedrag in",
  tripletaCustomAmount: "Ander bedrag",
  tripletaAmountRules: "Minimum {{min}} · veelvoude van {{step}}",
  tripletaPotentialPrize: "Potensiële prys",
  tripletaAccept: "AANVAAR",
  tripletaCancel: "KANSELLEER",
  tripletaBuying: "Koop tans…",
  tripletaBought: "Tripleta gekoop!",
  tripletaBoughtDetail: "Jou 3 figure speel die volgende {{n}} trekkings van {{game}}.",
  tripletaSeeMine: "Sien my tripletas",
  tripletaPlayAgain: "Speel nog een",
  tripletaMyTickets: "My tripletas",
  tripletaNoTickets: "Jy het nog geen tripletas nie",
  tripletaStatusOpen: "Oop",
  tripletaStatusWon: "Gewen",
  tripletaStatusLost: "Verloor",
  tripletaStatusVoid: "Gekanselleer",
  tripletaHits: "{{hits}} van 3 trefs",
  tripletaRemaining: "{{n}} trekkings oor",
  tripletaCanStillWin: "Jy kan steeds wen",
  tripletaCannotWin: "Kan nie meer die 3 voltooi nie",
  tripletaPrize: "Prys",
  tripletaCancelTicket: "Kanselleer kaartjie",
  tripletaCancelConfirm:
    "Die kaartjie word nietig verklaar en die bedrag terugbetaal. Slegs moontlik voor die eerste trekking sluit.",
  tripletaCancelled: "Kaartjie gekanselleer en terugbetaal",
  tripletaUnavailable: "Tripleta is tans nie beskikbaar nie",
  tripletaWindowUnavailable: "Nie genoeg aanstaande trekkings vir hierdie speletjie nie",
  tripletaErrSaleClosed:
    "Die eerste trekking het reeds gesluit. Ons het die trekkings verfris, kontroleer en probeer weer.",
  tripletaErrComboLimit: "Hierdie kombinasie het vandag se limiet bereik. Probeer 'n ander een.",
  tripletaErrInsufficient: "Onvoldoende saldo vir hierdie tripleta.",
  tripletaErrInvalidSelection: "Jy moet 3 verskillende figure kies.",
  tripletaErrInvalidAmount: "Ongeldige bedrag. Kontroleer die minimum en stap.",
  tripletaErrRateLimited: "Te veel aankope in 'n ry, wag 'n oomblik.",
  tripletaErrGeneric: "Kon nie die tripleta koop nie. Probeer weer.",
  tripletaDeposit: "Herlaai saldo",
  tripletaHowTitle: "Hoe werk dit?",
  tripletaHow1: "Kies 'n lotery en 3 verskillende figure.",
  tripletaHow2: "Jou kaartjie neem deel aan die volgende {{n}} trekkings van daardie lotery.",
  tripletaHow3: "Elke keer as een van jou figure uitkom, kry dit 'n ✓. Met al 3 gemerk, wen jy.",
  tripletaHow4: "Die prys is jou bedrag × die loteryvermenigvuldiger, onmiddellik gekrediteer.",
  tripletaResultPending: "Hangende",
  tripletaResultCame: "Het uitgekom {{n}}",
  tripletaSearch: "Soek dier of nommer",
  tripletaSearchPlaceholder: "Bv. Leeu of 05",
  tripletaShowAll: "Wys alles",
  tripletaNoFigures: "Geen diere gevind nie. Probeer 'n ander naam of nommer.",
  tripletaViewDraws: "Bekyk al {{count}} trekkings",

  lastPlaysTitle: "Jou onlangse spele",
  lastPlaysSubtitle: "Jou vertroude spele, een tik weg",
  lastPlaysPrev: "Vorige",
  lastPlaysNext: "Volgende",
  lastPlaysRepeat: "Herhaal",
  lastPlaysSelections: "keuses",
  lastPlaysModalTitle: "Herhaal spel",
  lastPlaysModalAria: "Herhaal spel",
  lastPlaysSelectDraw: "Trekkingstyd",
  lastPlaysNoDraws: "Geen trekkings beskikbaar",
  lastPlaysAmountLabel: "Bedrag per keuse",
  lastPlaysAmountPlaceholder: "Opsioneel",
  lastPlaysPerBetNote: "Oorspronklike bedrae sal gebruik word ({{total}} Bs totaal). Voer 'n bedrag in om te verenig.",
  lastPlaysTotalHint: "Totaal: {{total}} Bs ({{count}} keuses)",
  lastPlaysConfirm: "Bevestig — {{total}} Bs",
  lastPlaysSuccessTitle: "Spel herhaal!",
  lastPlaysSuccessAmount: "Totaal: {{amount}} Bs",
  lastPlaysClose: "Sluit",
  lastPlaysInvalidAmount: "Ongeldige bedrag",
};
